// Define school types
export const SCHOOL_TYPES = [
  "All",
  "Traditional Public",
  "Private",
  "Public Charter",
];

// Define school type colors
export const SCHOOL_TYPE_COLORS = {
  "Traditional Public": "#7cb1ef", // blue
  Private: "#f6c163", // gold/yellow
  "Public Charter": "#75c999", // green
};

// Define risk level options
export const RISK_LEVELS = [
  "All",
  "Lowest Vaccination Rate (0-20%)",
  "Low Vaccination Rate, (21-50%)",
  "Moderate Vaccination Rate (51-70%)",
  "High Vaccination Rate (71-89%)",
  "Highest Vaccination Rate (90-100%)",
];

// Define risk level colors
export const RISK_COLORS = {
  veryHigh: "#CD5E5F", // red
  high: "#F88B4C", // orange
  moderate: "#E9E80F", // yellow
  low: "#BED15B", // green
  veryLow: "#62A162", // darkgreen
};

// Risk level ranges for filtering
export const RISK_RANGES = {
  "Lowest Vaccination Rate (0-20%)": { min: 0, max: 20 },
  "Low Vaccination Rate, (21-50%)": { min: 21, max: 50 },
  "Moderate Vaccination Rate (51-70%)": { min: 51, max: 70 },
  "High Vaccination Rate (71-89%)": { min: 71, max: 89 },
  "Highest Vaccination Rate (90-100%)": { min: 90, max: 100 },
};

// Get color for risk level
export const getRiskLevelColor = (level: string): string => {
  if (level.includes("Lowest Vaccination Rate")) return RISK_COLORS.veryHigh;
  if (level.includes("Low Vaccination Rate")) return RISK_COLORS.high;
  if (level.includes("Moderate Vaccination Rate")) return RISK_COLORS.moderate;
  if (level.includes("High Vaccination Rate")) return RISK_COLORS.low;
  if (level.includes("Highest Vaccination Rate")) return RISK_COLORS.veryLow;
  return "";
};

// Function to determine risk level and color based on vaccination percentage
export const getVaccinationRiskColor = (
  percentage: number
): { color: string; label: string } => {
  if (percentage <= 20) {
    return {
      color: RISK_COLORS.veryHigh,
      label: "Lowest Vaccination Rate (0-20%)",
    };
  } else if (percentage <= 50) {
    return { color: RISK_COLORS.high, label: "Low Vaccination Rate, (21-50%)" };
  } else if (percentage <= 70) {
    return {
      color: RISK_COLORS.moderate,
      label: "Moderate Vaccination Rate (51-70%)",
    };
  } else if (percentage <= 89) {
    return { color: RISK_COLORS.low, label: "High Vaccination Rate (71-89%)" };
  } else {
    return {
      color: RISK_COLORS.veryLow,
      label: "Highest Vaccination Rate (90-100%)",
    };
  }
};
